export { Persona, renderPersona, usePersona } from './components/Persona';
export type { PersonaSlots, PersonaProps, PersonaState } from './components/Persona';
